
import React from "react";
import { Button } from "@/components/ui/button";
import { useOnboardingState } from "@/integrations/supabase/onboarding";
import { Link } from "react-router-dom";

const Step5DNI = ({ onPrev, onFinish }: { onPrev: () => void; onFinish: () => void }) => {
  const { onboarding, markComplete } = useOnboardingState();
  const tenantId = onboarding?.tenant_id;
  const snippet = tenantId
    ? `<script defer src="https://ktywphxmqafinzfgzhps.supabase.co/functions/v1/Calie_dniScript?tenant_id=${tenantId}"></script>`
    : "<!-- DNI script will be available after onboarding initializes -->";
  const copySnippet = () => {
    navigator.clipboard.writeText(snippet);
  };
  const handleFinish = async () => {
    await markComplete?.();
    onFinish();
  };

  return (
    <div className="flex flex-col items-center justify-center space-y-4">
      <div className="w-full">
        <label className="block mb-2 font-medium">DNI Snippet</label>
        <textarea
          value={snippet}
          readOnly
          className="w-full h-32 border rounded p-2 text-sm bg-muted"
        />
        <div className="mt-2 flex flex-wrap items-center gap-2">
          <Button onClick={copySnippet}>Copy to Clipboard</Button>
          {tenantId && (
            <Button variant="outline" asChild>
              <Link to={`/dni-test?tenant_id=${tenantId}`}>Open Test Page</Link>
            </Button>
          )}
        </div>
      </div>
      <div className="flex space-x-2">
        <Button type="button" variant="secondary" onClick={onPrev}>Back</Button>
        <Button type="button" onClick={handleFinish}>Finish & Close</Button>
      </div>
    </div>
  );
};
export default Step5DNI;
